const ANIMATION_LENGTH = 400;
const animations = new Map<HTMLElement, NodeJS.Timeout>();

type StartAnimationConfiguration = {
  element: HTMLElement | null;
  fromStep: number;
  onAnimationStart?: () => void;
  onAnimationEnd?: () => void;
  toStep: number;
  totalSteps: number;
};

export const startAnimation = ({ element, fromStep, onAnimationEnd = () => {}, toStep, totalSteps }: StartAnimationConfiguration) => {
  if (!element) {
    return;
  }
  if (animations.has(element)) clearInterval(animations.get(element));
  if (fromStep === toStep) {
    onAnimationEnd();
    return;
  }

  let step = fromStep;
  let interval: NodeJS.Timeout;
  const direction = fromStep <= toStep ? 'forward' : 'backward';
  const animatedSteps = Math.abs(toStep - fromStep);

  const executeStep = () => {
    element.style.setProperty('--sprite-translate-x', `-${(100 / totalSteps) * step}%`);

    if (step === toStep) {
      onAnimationEnd();
      interval && clearInterval(interval);
    }

    if (direction === 'forward') {
      step = (step + 1) % totalSteps;
    } else {
      step = (step - 1 + totalSteps) % totalSteps;
    }
  };

  // Execute the first step immediately
  executeStep();

  // Start the interval from the next step
  interval = setInterval(() => {
    executeStep();
  }, ANIMATION_LENGTH / animatedSteps);

  animations.set(element, interval);
};